import request from '../../plugins/request'

// 列表
export function apiGetLabelsByParm(data) {
	return request({
		url: '/api/Label/GetLabelsByParm',
		method: 'post',
		baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}

// 新增tag
export function apiGetAddLabel(data) {
	return request({
		url: '/api/Label/AddLable',
		method: 'post',
		baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}


// 列表编辑
export function apiUpdateLableById(data) {
	return request({
		url: '/api/Label/UpdateLableById',
		method: 'post',
		baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}

// 删除
export function apiDeleteLableById(data) {
	return request({
		url: '/api/Label/DeleteLabelById',
		method: 'post',
		baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}


export function apiGetLabelContactBook(data) {
	return request({
		url: '/api/AuthorLableShips/GetLabelShipByParm',
		method: 'post',
		// baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}


export function apiSaveLableContactBook(data) {
	return request({
		url: '/api/AuthorLableShips/AddLabelShip',
		method: 'post',
		// baseURL: `${process.env.VUE_APP_NOVEL_API}`,
		data
	})
}